<template>
  <div class="t_syk1bg">
    <div class="bg-img-title pc animate__animated animate__fadeInRight">
      <p>{{ $t('lang.homeText') }}</p>
      <p style="margin-left: 80px;position: relative" class="homeText-left">{{ $t('lang.homeText1') }}</p>
    </div>
    <div class="bg-img-title phone animate__animated animate__fadeInRight">
      <span>{{ $t('lang.homeText') + '—' + $t('lang.homeText1') }}</span>
    </div>
    <div class="nesc_a1t_bg animate__animated animate__fadeIn" style="position:relative;padding-bottom: 51%;box-sizing: content-box;height: 0">
      <img class="animate__animated animate__fadeIn" src="../assets/image/home.jpeg?v=3" style="width: 100%;" alt="">
      <ul class="mc_pos_cover" :class="{show: coverShow}">
        <li v-for="(item, index) in targetList" :key="index" class="mc_a1t_li animate__animated animate__fadeIn" :style="{'left': `calc(`+item.left+` - 32px)`, 'top': `calc(`+item.top+` - 32px)`}">
          <div class="t_syk1icon">
            <div class="t_sykuo">
              <img class="t_syyuan" src="../assets/image/logo.jpg" style="" alt="">
              <img class="t_syhover" :src="require('../assets/image/home/' + item.img+'.png')" alt="">
            </div>
          </div>

          <router-link class="mc_a1t_xl flex-row-left" :to="item.url">
            <span class="mc_a1t_title">{{ $t('lang.' + item.title) }}</span>
            <span class="mc_a1t_jiantou">
              <i class="el-icon-arrow-right" />
            </span>
          </router-link>
        </li>
      </ul>
    </div>

    <!-- 首页新闻 -->
    <div v-loading="loading" class="fp-tableCell" style="display: table-cell; vertical-align: middle; width: 100%;">
      <div class="content2 margin-top-xxl" style="background: #f7f8fa">
        <div class="t_syk3tit flex-row-between">
          <div class="t_ywh1">
            <h2>{{ $t('lang.newsTitle') }}</h2>
          </div>
          <router-link to="/about/news" class="flex-row-left checkMore">
            <span style="font-size: 14px;font-weight: bold;color: #666666">{{ $t('lang.checkMore') }}</span>
            <i class="icon-nextstep" />
          </router-link>
        </div>

        <div class="n_nesc3new margin-top">
          <ul class="flex-row-left" style="flex-flow: wrap">
            <li v-for="item in newsList" :key="item.NewsInfoId" class="n_news3li">
              <router-link :to="{ name: 'newsDetail', params: { id: item.NewsInfoId, time: item.CreateTime }}" style="display: block">
                <div class="n_nesc3xin">
                  <div class="n_nesc3pic">
                    <img class="n_tou" src="../assets/image/syk3_h.png" alt="">
                    <img class="n_shi" :src="imgServer + item.CoverImage" alt="guanwang.jpg">
                  </div>
                  <div class="n_nesc3wen">
                    <p class="n_nesc3wen_p">{{ item.Title }}</p>
                    <div class="n_nesc3date">{{ item.CreateTime }}</div>
                    <div class="t_jiancir flex-row-center">
                      <i class="el-icon-arrow-right" />
                    </div>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data: () => {
    return {
      targetList: [
        { title: 'companyProfile', top: '42.46%', left: '54.5%', img: 'nesc', url: '/about/companyProfile' },
        { title: 'technology', top: '29.56%', left: '50.67%', img: 'nesc', url: '/technology/materialTechnology' },
        { title: 'lightPassengerVehicle', top: '52.35%', left: '48.07%', img: 'siLunChe', url: '/solutions/lightPassengerVehicle' },
        { title: 'drone', top: '43.92%', left: '76.77%', img: 'wuRenJi', url: '/solutions/drone' },
        { title: 'electricalTools', top: '53.19%', left: '75.67%', img: 'elecTools', url: '/solutions/electricalTools' },
        { title: 'heavyTransport', left: '42.93%', top: '23.65%', img: 'heavyCar', url: '/solutions/heavyTransport' },
        { title: 'logisticsFreight', left: '32.89%', top: '55.93%', img: 'huoyun', url: '/solutions/logisticsFreight' },

        { title: 'cityDelivery', top: '68.73%', left: '48.6%', img: 'liangLunChe', url: '/solutions/cityDelivery' },
        { title: 'highSpeedMotorcycle', left: '45.96%', top: '72.73%', img: 'dianmo', url: '/solutions/highSpeedMotorcycle' }

      ],
      newsList: [],
      loading: !0,
      coverShow: !1
    }
  },

  mounted() {
    this.imgServer = this.domainUrl
    setTimeout(() => {
      this.coverShow = !0
    }, 50)
    this.$http.post(this.isDevelop ? '/NewsList' : '/api/NewsService/NewsList', { page: 1, limit: 3 }).then(
      (responseNews) => {
        responseNews.statusText == 'OK' && responseNews.data.data.length > 0 && (
          this.newsList = responseNews.data.data || [],
          this.loading = !1
        )
      }
    ).catch(function() {
      this.newsList = []
    })
  },

  methods: {
    gotoPage(path) {
      window.href = path
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/news';

.t_syk1bg {
  width: 100%;
  overflow: hidden;
  position: relative;
  top: 0;
  display: flex;
  flex-direction: column;
}

/* 首页中间文字 */
.bg-img-title {
  position: absolute;
  z-index: 10;
  color: #575757;
  letter-spacing: 1px;
  font-weight: bold;
  font-size: 28px;
  font-family: "OPPOSansWeb2", "微软雅黑", Arial, "PingFangSC-Light", "Helvetica Neue", Helvetica, "Microsoft Yahei", "Hiragino Sans GB", tahoma, SimSun, sans-serif;

  &.phone {
    width: 100%;
    text-align: center;
    top: 30px;
  }
  &.pc {
    left: 5.9%;
    top: 50px;
  }
  @media screen and (max-width: 1920px){
    font-size: 26px;
  }

  @media screen and (max-width: 1366px){
    font-size: 20px;
  }

  @media screen and (max-width: 1024px){
    &.phone {display: block;padding-left: 10px;padding-right: 10px;};
    &.pc {display: none};
  }

  @media screen and (min-width: 1025px){
    &.phone {display: none};
    &.pc {display: block};
  }

  @media screen and (max-width: 1199px){
    font-size: 18px;
  }
  @media screen and (max-width: 768px){
    font-size: 16px;
    letter-spacing: 0px;
  }
  @media screen and (max-width: 468px){
    &.phone {
      top: 10px;
    }
  }

  .homeText-left::before {
    content: '';
    width: 36px;
    height: 2px;
    background: #575757;
    position: absolute;
    left: -44px;
    top: 50%;
  }
}

/* 首页背景图片 */
.nesc_a1t_bg {
  position: relative;
  padding-bottom:20px;
  @media screen and (min-width: 1025px) {
    margin-top: -14px;
  }
  @media screen and (max-width: 1024px) {
    margin-top: 10px;
  }
  @media screen and (max-width: 768px) {
    margin-top: 20px;
  }
  img {
    max-width: 100%;object-fit: contain;vertical-align: middle;
  }
}

/* li容器 */
.mc_pos_cover {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  visibility: hidden;

  .mc_a1t_li {
    position: absolute;
    z-index: 5;
    &:hover {
      z-index: 20;
    }
  }
  &.show {
    visibility: visible;
  }
}

.t_syk1icon {
  width: 64px;
  height: 64px;
  position: relative;
}

.t_syyuan {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position:absolute;
  left:50%;top: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
  vertical-align:middle;
}

.t_syhover {
  height: 64px;
  position:absolute;
  left:50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
  visibility: hidden;
  vertical-align:middle;
}

.t_sykuo {
  &::before {
    content: '';
    background: rgba(234, 104, 40, .7);
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    @media screen and (min-width: 768px){
      width: 40px;
      height: 40px;
      animation: kuosan 2.2s linear 0.5s infinite;
    }
    @media screen and (max-width: 767px){
      width: 20px;
      height: 20px;
      animation: kuosan-phone 2.2s linear 0.5s infinite;
    }

  }
  &::after {
    content: '';
    background: rgba(234, 104, 40, .7);
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    @media screen and (min-width: 768px){
      width: 40px;
      height: 40px;
      animation: kuosan 2.2s linear 1.2s infinite;
    }
    @media screen and (max-width: 767px){
      width: 20px;
      height: 20px;
      animation: kuosan-phone 2.2s linear 1.2s infinite;
    }
  }
}

@keyframes kuosan {
  0% {
    width: 24px;
    height: 24px;
    opacity: 1;
  }

  50% {
    width: 40px;
    height: 40px;
    opacity:  1;
  }
  75% {
    width: 50px;
    height: 50px;
    opacity: 0.5;
  }
  100%{
    width: 60px;
    height: 60px;
    opacity: 0.2;
  }
}

@keyframes kuosan-phone {
  0% {
    width: 12px;
    height: 12px;
    opacity: 1;
  }

  50% {
    width: 20px;
    height: 20px;
    opacity:  1;
  }
  75% {
    width: 25px;
    height: 25px;
    opacity: 0.5;
  }
  100%{
    width: 30px;
    height: 30px;
    opacity: 0.2;
  }
}

/* router-link */
.mc_a1t_xl {
  position: absolute;
  left: 63px;
  top:10px;
  z-index: 1;
  white-space: nowrap;
  font-size: 16px;
  padding: 0 23px;
  line-height: 40px;
  visibility: hidden;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 0;
    height: 100%;
    border-radius: 20px;
    background: -webkit-linear-gradient(left, #EA6828, #fca85f);
  }

  span {opacity: 0;}
  /* 向右箭头 */
  .mc_a1t_jiantou {
    font-size: 14px;
    color: #ffffff;
    vertical-align: middle;
  }
  /* 文本说明 */
  .mc_a1t_title {
    color: #ffffff;
    font-size: 16px;
    margin-right: 10px;
    vertical-align: middle;
  }
}

.mc_a1t_li:hover {
  .mc_a1t_xl {
    visibility: visible;
  }

  .t_syhover {
    visibility: visible;
  }

  .t_syyuan {
    visibility: hidden;
  }

  .t_sykuo::before {
    display: none;
  }

  .t_sykuo::after {
    display: none;
  }

  .mc_a1t_xl::before {
    width: 100%;
    transition: all .4s cubic-bezier(.34, .44, .41, 1.12);
  }

  .mc_a1t_xl span {
    opacity: 1;
    transition: all .36s .4s;
  }
}

/* 新闻 */
.content2 {
  width: 1500px;
  margin: 0 auto;
  padding-bottom: 60px;
}

.icon-nextstep {
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-nextstep:before {
  content: "→";
  display: inline-block;
  font-family: "微软雅黑", Arial, "PingFangSC-Light", "Helvetica Neue", Helvetica, "Microsoft Yahei", "Hiragino Sans GB", tahoma, SimSun, sans-serif;
  vertical-align: middle;
  transform: translateX(5px);
  transition: transform 0.25s ease 0s;
}

.checkMore:hover {
  span {color: #EA6828 !important;}
  .icon-nextstep {
    color: #EA6828;
  }

  .icon-nextstep:before {
    transform: translateX(10px);
    transition: transform 0.25s ease 0s;
  }
}

.t_syk3tit {
  padding-top: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e5e5e5;
}

@media screen and (max-width: 1680px) {
  .content2 {
    padding-left: 200px;
    padding-right: 200px;
    width: 100%;
  }
}
@media screen and (max-width: 1560px) {
  .content2 {
    padding-left: 150px;
    padding-right: 150px;
  }
}
@media screen and (max-width: 1440px) {
  .content2 {
    padding-left: 108px;
    padding-right: 108px;
  }
}

@media screen and (max-width: 950px) {
  .content2 {
    padding-left: 20px;
    padding-right: 20px;
  }
}

@media screen and (max-width: 767px) {
  .t_syk1icon {
    width: 32px;height: 32px;position: relative;
  }
  .t_syyuan {
    width: 16px;
    height: 16px;
  }
  .t_syhover {
    height: 32px;
  }
  .mc_a1t_xl {
    left: -10px;
    top: 40px;
  }
}

</style>
